import React from 'react';
import { FormattedMessage } from 'react-intl';

import { STATUS } from './options/status';
import { SHIP_DATES } from './options/ship-date';
import { CREATE_DATES } from './options/create-date';
import { statusMessages } from './options/messages';

const buildCriterionArgumentObject = (id: string, displayMessage: typeof statusMessages.quoted, value: string) => ({
  id,
  displayName: <FormattedMessage {...displayMessage} />,
  value,
});

const StatusValueMessages: Record<string, typeof statusMessages.quoted> = {
  Quoted: statusMessages.quoted,
  Booked: statusMessages.booked,
  Cancelled: statusMessages.cancelled,
};

const staticCriteriaArguments = {
  [STATUS]: Object.keys(StatusValueMessages).map((key) => buildCriterionArgumentObject(key, StatusValueMessages[key], key)),
  [SHIP_DATES]: [],
  [CREATE_DATES]: [],
};

export default staticCriteriaArguments;
